import { Box, Typography } from "@mui/material";
import React from "react";

interface IPropsTypes {
  subtitle?: string;
  height?: number | string;
}

export const NoData: React.FC<IPropsTypes> = (props) => {
  const {
    subtitle = "Double check for your search entry or reset your applied filters",
    height,
  } = props;

  return (
    <Box
      data-testid="no-data-box"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height={height ?? (subtitle ? 290 : 320)}
      p={3}
    >
      <Typography
        data-testid="no-data-title"
        fontWeight={600}
        variant="h6"
        textAlign={"center"}
      >
        No data
      </Typography>
      <Typography data-testid="no-data-message" textAlign={"center"}>
        {subtitle}
      </Typography>
    </Box>
  );
};
